<template>
	<div>
		<v-list dense rounded v-if="data">
			<v-list-item>
				<v-list-item-content>
					<v-file-input
						v-model="data.file"
						label="Select file for upload"
						prepend-icon="mdi-attachment"
						show-size
					/>
				</v-list-item-content>
			</v-list-item>
		</v-list>
	</div>
</template>

<script>
export default {
	name: 'FileForm',
	props: {
		data: Object,
	},
}
</script>

<style lang="scss" scoped>
</style>